import { Suspense } from "react";
import { Canvas } from '@react-three/fiber'
import Model from './Model';
import { Environment} from '@react-three/drei'
import './crystal.scss'
import { Preload } from "@react-three/drei";
import environment from './environment.jpg';

export default function Crystal({currentScrollTop}) {

  return (
    <div className="crystal">
      <Canvas  gl={{antialias: true,alpha: true,powerPreference: 'high-performance'}} style={{ pointerEvents: "none" }}>
        <Suspense fallback={null}>
          <Model moved={currentScrollTop}/>
          <Preload all />
          <directionalLight intensity={2} position={[0, 2, 3]}/>
          <Environment files={environment} />
        </Suspense>
      </Canvas>
    </div>
  )
}
